import { AvailabilityType } from '@interfaces';
import { styled } from '@mui/system';

const background: Partial<Record<AvailabilityType, string>> = {
  AVAILABLE: '#E6F3FA',
  AVAILABLE_24_HRS: '#eff5ef',
  CHECK: '#E6F3FA',
  SOLD_OUT: '#FFE2E2',
};

const color: Partial<Record<AvailabilityType, string>> = {
  AVAILABLE: '#15365F',
  AVAILABLE_24_HRS: '#284525',
  CHECK: '#2D0076',
  SOLD_OUT: '#602D11',
};

const fill: Partial<Record<AvailabilityType, string>> = {
  AVAILABLE: '#0277BD',
  AVAILABLE_24_HRS: '#00A650',
  CHECK: '#731EFF',
  SOLD_OUT: '#FF0000',
};

const Container = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  margin: '0 -8px',
});

const ChipContainer = styled('div')<{ availability: AvailabilityType }>(
  ({ availability }) => ({
    backgroundColor: background[availability] ?? background.SOLD_OUT,
    display: 'flex',
    flexDirection: 'row',
    gap: 4,
    justifyContent: 'center',
    alignItems: 'center',
    padding: '0 8px',
    borderRadius: 16,
    width: 'fit-content',
    margin: '10px auto',
  }),
);

const IconContainer = styled('div')<{ availability: AvailabilityType }>(
  ({ availability }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& > svg': {
      height: 14,
      width: 14,
      fontSize: 9,
      fill: fill[availability] ?? fill.SOLD_OUT,
    },
  }),
);

const Label = styled('span')<{ availability: AvailabilityType }>(
  ({ availability }) => ({
    color: color[availability] ?? color.SOLD_OUT,
    display: 'block',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    fontSize: 12,
  }),
);

const EmptyChip = styled('div')({
  height: 21,
  margin: '10px auto',
});

export { Container, ChipContainer, IconContainer, Label, EmptyChip };
